module.exports = __webpack_public_path__ + "img/yalobusha-review-1.27a5b87f.png";